import script from "./policy-bind-scope.vue?vue&type=script&lang=ts&setup=true"
export * from "./policy-bind-scope.vue?vue&type=script&lang=ts&setup=true"

import "./policy-bind-scope.vue?vue&type=style&index=0&id=11448aff&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11448aff"]])

export default __exports__